import m from "mithril";
import CoordMobileLayout from "./Coord-mobile-layout.js";
import { formatRupiah } from "../utils.js";
import dataLayer from "../pwa/data-layer.js";

const CoordMobileRekapSimpananHistory = {
    transactions: [],
    isLoading: false,
    error: null,
    productId: null,
    productName: '',
    transactionType: 'deposit', // 'deposit' or 'withdrawal'
    startDate: '',
    endDate: '',
    filterApplied: false,

    async oninit(vnode) {
        this.productId = vnode.attrs.productId || m.route.param('productId');
        this.transactionType = vnode.attrs.transactionType || m.route.param('transactionType') || 'deposit';
        await this.loadProductName();
        await this.loadTransactions();
    },

    async loadProductName() {
        try {
            const product = await dataLayer.getSavingProductById(this.productId);
            if (product) {
                this.productName = product.name;
            }
        } catch (e) {
            console.error('Error loading product name:', e);
        }
    },

    async loadTransactions() {
        try {
            this.isLoading = true;
            this.error = null;
            m.redraw();

            // Build query parameters
            const params = {
                productId: this.productId,
                transaction_type: this.transactionType
            };

            if (this.startDate) params.startDate = this.startDate;
            if (this.endDate) params.endDate = this.endDate;

            console.log('[RekapSimpanan] Loading with params:', params);

            // Use dataLayer for cache-first reads with background refresh
            const data = await dataLayer.getRekapSimpanan(params);
            
            console.log('[RekapSimpanan] Received data:', data?.length, 'transactions');
            if (data && data.length > 0) {
                console.log('[RekapSimpanan] Sample transaction:', data[0]);
            }
            
            this.transactions = data || [];
            this.filterApplied = !!(this.startDate || this.endDate);
        } catch (error) {
            console.error('Error loading transactions:', error);
            this.error = 'Gagal memuat data transaksi: ' + error.message;
        } finally {
            this.isLoading = false;
            m.redraw();
        }
    },

    applyFilter() {
        this.loadTransactions();
    },

    clearFilter() {
        this.startDate = '';
        this.endDate = '';
        this.loadTransactions();
    },

    switchType(type) {
        this.transactionType = type;
        this.startDate = '';
        this.endDate = '';
        this.loadTransactions();
    },

    view() {
        const isDeposit = this.transactionType === 'deposit';
        const content = m("div", { class: "min-h-screen bg-gray-50 dark:bg-gray-900 pb-20" }, [
            // Header
            m("div", { class: "bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700 sticky top-0 z-10" }, [
                m("div", { class: "px-4 py-3" }, [
                    m("div", { class: "flex items-center mb-2" }, [
                        m("button", {
                            class: "mr-3 text-gray-600 dark:text-gray-300 hover:text-green-600 dark:hover:text-green-400 transition-colors",
                            onclick: () => m.route.set('/coord-rekap-simpanan-mobile')
                        }, [
                            m("i", { class: "ri-arrow-left-line text-xl" })
                        ]),
                        m("div", [
                            m("h1", { class: "text-lg font-bold text-gray-800 dark:text-white" }, 
                                isDeposit ? "Riwayat Setoran" : "Riwayat Penarikan"
                            ),
                            m("p", { class: "text-xs text-gray-600 dark:text-gray-300" }, this.productName || 'Produk Simpanan')
                        ])
                    ]),

                    // Type Toggle
                    m("div", { class: "grid grid-cols-2 gap-2 mb-3" }, [
                        m("button", {
                            class: `py-2 px-3 rounded-lg text-sm font-medium transition-colors ${
                                isDeposit 
                                    ? 'bg-green-600 text-white' 
                                    : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                            }`,
                            onclick: () => this.switchType('deposit')
                        }, [
                            m("i", { class: "ri-arrow-down-circle-line mr-1" }),
                            "Setoran"
                        ]),
                        m("button", {
                            class: `py-2 px-3 rounded-lg text-sm font-medium transition-colors ${
                                !isDeposit 
                                    ? 'bg-orange-600 text-white' 
                                    : 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600'
                            }`,
                            onclick: () => this.switchType('withdrawal')
                        }, [
                            m("i", { class: "ri-arrow-up-circle-line mr-1" }),
                            "Penarikan"
                        ])
                    ]),

                    // Date Range Filter
                    m("div", { class: "bg-gray-50 dark:bg-gray-700 rounded-lg p-3" }, [
                        m("div", { class: "grid grid-cols-2 gap-2 mb-2" }, [
                            m("div", [
                                m("label", { class: "block text-xs text-gray-600 dark:text-gray-300 mb-1" }, "Dari Tanggal"),
                                m("input", {
                                    type: "date",
                                    class: "w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-800 dark:text-white",
                                    value: this.startDate,
                                    onchange: (e) => { this.startDate = e.target.value; m.redraw(); }
                                })
                            ]),
                            m("div", [
                                m("label", { class: "block text-xs text-gray-600 dark:text-gray-300 mb-1" }, "Sampai Tanggal"),
                                m("input", {
                                    type: "date",
                                    class: "w-full px-2 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-800 dark:text-white",
                                    value: this.endDate,
                                    onchange: (e) => { this.endDate = e.target.value; m.redraw(); }
                                })
                            ])
                        ]),
                        m("div", { class: "flex gap-2" }, [
                            m("button", {
                                class: "flex-1 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-lg transition-colors",
                                onclick: () => this.applyFilter()
                            }, "Terapkan"),
                            this.filterApplied ? m("button", {
                                class: "flex-1 px-3 py-1.5 bg-gray-600 hover:bg-gray-700 text-white text-xs font-medium rounded-lg transition-colors",
                                onclick: () => this.clearFilter()
                            }, "Reset") : null
                        ])
                    ])
                ])
            ]),

            // Main Content
            m("div", { class: "p-4" }, [
                this.isLoading ? 
                    m("div", { class: "flex justify-center items-center py-12" }, [
                        m("i", { class: "ri-loader-4-line animate-spin text-3xl text-green-600" })
                    ]) :
                    
                this.error ?
                    m("div", { class: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4 text-center" }, [
                        m("i", { class: "ri-error-warning-line text-red-600 text-2xl mb-2" }),
                        m("p", { class: "text-sm text-red-800 dark:text-red-200" }, this.error),
                        m("button", {
                            class: "mt-3 px-4 py-2 bg-red-600 text-white rounded-lg text-sm",
                            onclick: () => this.loadTransactions()
                        }, "Coba Lagi")
                    ]) :

                this.transactions.length === 0 ?
                    m("div", { class: "text-center py-12" }, [
                        m("i", { class: "ri-inbox-line text-gray-400 text-4xl mb-3" }),
                        m("p", { class: "text-gray-600 dark:text-gray-300 text-sm" }, 
                            this.filterApplied ? "Tidak ada data untuk periode yang dipilih" : `Belum ada riwayat ${isDeposit ? 'setoran' : 'penarikan'}`
                        )
                    ]) :

                    m("div", { class: "space-y-3" }, [
                        // Summary Card
                        m("div", { 
                            class: `bg-gradient-to-r ${isDeposit ? 'from-green-500 to-green-600' : 'from-orange-500 to-orange-600'} rounded-xl p-4 text-white mb-4` 
                        }, [
                            m("div", { class: "flex justify-between items-center" }, [
                                m("div", [
                                    m("p", { class: "text-xs text-white/80 mb-1" }, `Total ${isDeposit ? 'Setoran' : 'Penarikan'}`),
                                    m("p", { class: "text-xl font-bold" }, formatRupiah(
                                        this.transactions.reduce((sum, tx) => sum + parseFloat(tx.total || 0), 0)
                                    ))
                                ]),
                                m("div", { class: "text-right" }, [
                                    m("p", { class: "text-xs text-white/80 mb-1" }, "Jumlah Transaksi"),
                                    m("p", { class: "text-2xl font-bold" }, this.transactions.length)
                                ])
                            ])
                        ]),

                        // Transaction List
                        this.transactions.map(tx => 
                            m("div", {
                                key: tx.id,
                                class: "bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-200 dark:border-gray-700"
                            }, [
                                m("div", { class: "flex items-start justify-between mb-3" }, [
                                    m("div", [
                                        m("p", { class: "font-semibold text-gray-800 dark:text-white text-sm" }, 
                                            tx.customer_name || 'Nasabah'
                                        ),
                                        m("p", { class: "text-xs text-gray-600 dark:text-gray-300 mt-0.5" }, 
                                            `No. Rek: ${tx.account_number || '-'}`
                                        )
                                    ]),
                                    m("div", { class: "text-right" }, [
                                        m("p", { 
                                            class: `font-bold text-sm ${isDeposit ? 'text-green-600 dark:text-green-400' : 'text-orange-600 dark:text-orange-400'}` 
                                        }, 
                                            `${isDeposit ? '+' : '-'} ${formatRupiah(tx.total || 0)}`
                                        ),
                                        m("p", { class: "text-xs text-gray-500 dark:text-gray-400 mt-0.5" }, 
                                            new Date(tx.tgl).toLocaleDateString('id-ID')
                                        )
                                    ])
                                ]),
                                
                                // Additional details
                                tx.deskripsi ? m("div", { class: "pt-3 border-t border-gray-100 dark:border-gray-700" }, [
                                    m("p", { class: "text-xs text-gray-600 dark:text-gray-400" }, [
                                        m("span", { class: "font-medium" }, "Keterangan: "),
                                        tx.deskripsi
                                    ])
                                ]) : null
                            ])
                        )
                    ])
            ])
        ]);

        return m(CoordMobileLayout, { activeTab: null }, content);
    }
};

export default CoordMobileRekapSimpananHistory;
